@switch (state) {
@case (LogWorkState.NONE) {
<form [formGroup]="formGroup">
  <div class="container">
    <h2 class="employer-name">{{ employerName }}</h2>
  </div>
  <div class="log-work-form container">
    <mat-form-field appearance="outline" class="log-work-select">
      <mat-label>{{ 'DF-Agreement' | translate }}</mat-label>
      <mat-select #matSelect formControlName="activeAgreement">
        @for (agreement of agreements; track agreement) {
        <mat-option [value]="agreement.Id">{{ agreement.EmploymentDateFrom | date : 'yyyy-MM-dd' }} - {{
          agreement.EmploymentDateTo | date : 'yyyy-MM-dd' }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="container">
    <p [innerHTML]="registrationText | safeHtml"></p>
  </div>
  <div class="container">
    <button [disabled]="!selectedAgreement" mat-raised-button color="primary" class="confirmation-button"
      (click)="submit(false, true)">
      {{ 'LogWork.ConfirmRegistration' | translate }}
    </button>
    <p class="auto-confirm" [innerHTML]="countdownText | safeHtml"></p>
  </div>
  <div class="container">
    <p>{{ 'LogWork.ChangeRegistrationInfo' | translate }}</p>
  </div>
  <div class="container">
    <button [disabled]="!selectedAgreement" mat-raised-button color="accent" class="confirmation-button"
      (click)="submit(true, true)">
      {{ 'LogWork.ChangeRegistration' | translate }}
    </button>
  </div>
  <div class="container">
    <button mat-raised-button color="accent" class="confirmation-button" (click)="cancel()">
      {{ 'Cancel' | translate }}
    </button>
  </div>
</form>
}
@case (LogWorkState.ERROR) {
<div class="container">
  <mat-icon fontSet="material-icons-outlined" class="large-icon error-icon">cancel</mat-icon>
</div>
<div class="container">
  <p>{{ errorMessage | translate }}</p>
</div>
<div class="container">
  <button mat-raised-button color="accent" class="confirmation-button" (click)="redirectToTimesheets()">
    {{ 'LogWork.RedirectToTimesheets' | translate }}
  </button>
</div>
}
@case (LogWorkState.SUCCESS) {
<div class="container">
  <mat-icon class="large-icon success-icon">check_circle_outline</mat-icon>
</div>
<div class="container">
  <p>{{ successMessage | translate }}</p>
</div>
<div class="container">
  <button mat-raised-button color="accent" class="confirmation-button" (click)="redirectToTimesheets()">
    {{ 'LogWork.RedirectToTimesheets' | translate }}
  </button>
</div>
}
@case (LogWorkState.CANCELLED) {
<div class="container">
  <mat-icon fontSet="material-icons-outlined" class="large-icon info-icon">info</mat-icon>
</div>
<div class="container">
  <p>{{ 'LogWork.CancelledInformation' | translate }}</p>
</div>
<div class="container">
  <button mat-raised-button color="accent" class="confirmation-button" (click)="redirectToTimesheets()">
    {{ 'LogWork.RedirectToTimesheets' | translate }}
  </button>
</div>
}
}
